import {parseUrl} from './parse-url';

(function xhrPatch() {
    const genericError = 'Service temporary unavailable, please refresh the page or try again later';

    function getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }

    const _xhrOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function (...args) {
        const result = _xhrOpen.apply(this, args);

        const method = args[0];
        const url = args[1];

        const csrfToken = getCookie('XSRF-TOKEN');
        const host = parseUrl(url).host;

        if (csrfToken && method !== 'GET' && method !== 'HEAD' && host === location.host) {
            this.setRequestHeader('X-XSRF-TOKEN', csrfToken);
        }

        if (host === location.host) {
            this.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

            this.addEventListener(
                'readystatechange',
                () => {
                    const responseType = this.getResponseHeader('Content-Type');

                    if (this.status === 503 && responseType.indexOf('text/html') !== -1) {
                        Object.defineProperty(this, 'responseText', {
                            writable: true,
                        });

                        this.responseText = genericError;
                    }
                },
                false,
            );
        }

        return result;
    };

    if (window.fetch) {
        const _fetch = window.fetch;

        window.fetch = async function (url, initOptions = {}) {
            const csrfToken = getCookie('XSRF-TOKEN');
            const host = parseUrl(url).host;

            const opts = initOptions || {};
            opts.headers = opts.headers || {};

            if (!opts.credentials) {
                opts.credentials = 'same-origin';
            }

            if (host === location.host) {
                if (opts.headers instanceof Headers && !opts.headers.get('X-Requested-With')) {
                    opts.headers.append('X-Requested-With', 'XMLHttpRequest');
                } else {
                    opts.headers['X-Requested-With'] = 'XMLHttpRequest';
                }
            }

            // We do POST query to algolia for example, we shoud not send our csrf token
            if (csrfToken && opts.method !== 'GET' && opts.method !== 'HEAD' && host === location.host) {
                if (opts.headers instanceof Headers && !opts.headers.get('X-XSRF-TOKEN')) {
                    opts.headers.append('X-XSRF-TOKEN', csrfToken);
                } else {
                    opts.headers['X-XSRF-TOKEN'] = csrfToken;
                }
            }

            const response = await _fetch(url, opts);

            if (host === location.host && response.status === 503) {
                // We need to clone response in order to avoid :
                // Failed to execute 'json' on 'Response': body stream is locked
                const responseType = response.headers.get('content-type');

                if (responseType.indexOf('text/html') !== -1) {
                    // Mock the response with all the possibilities I can found in our codebase, in terms of response handling
                    return {
                        ok: false,
                        status: 503,
                        json: async () => {
                            return genericError;
                        },
                        text: async () => {
                            return genericError;
                        },
                        responseText: genericError,
                    };
                }
            } else {
                return response;
            }
        };
    }
})();
